import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AttachmentDeadlineInfo, AttachmentTypeInfo, NomineeTypeInfo } from '../../services/application/application.service';
import { DownloadFormat, DownloadService, HttpMethod } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';

@Component({
    selector: 'app-publicattachmentpanel',
    templateUrl: './publicattachmentpanel.component.html',
    styleUrls: ['./publicattachmentpanel.component.css']
})

export class PublicattachmentpanelComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();

    @Input() AttachmentType: AttachmentTypeInfo;
    @Input() FileWindowDeadline: AttachmentDeadlineInfo;
    @Input() NomineeType: NomineeTypeInfo;
    @Input() Instructions: string;
    @Input() SiteName: string;
    @Output() uploaded = new EventEmitter<File>();

    FileWindowOpen: boolean;
    HasFileSizeLimit: boolean;
    fileTypeInvalid: boolean;
    fileSizeOver: boolean;
    fileSizeUnder: boolean;
    hasBlankDocument: boolean;
    fileType: string;
    chosenFile: File;

    constructor(
        private splashSvc: SplashService,
        private downloadSvc: DownloadService,
        private errSvc: ErrorService) { }

    ngOnInit(): void {
        this.FileWindowOpen = (this.FileWindowDeadline && this.FileWindowDeadline.WindowOpen);
        this.HasFileSizeLimit = (this.AttachmentType
            && this.AttachmentType.SizeLimit != null
            && this.AttachmentType.SizeLimit > 0
            && this.AttachmentType.LowerSizeLimit != null
            && this.AttachmentType.LowerSizeLimit > 0);

        this.fileSizeOver = false;
        this.fileSizeUnder = false;
        this.fileTypeInvalid = false;
        this.hasBlankDocument = this.AttachmentType.DownloadFile != null;
        this.chosenFile = null;

        if (this.AttachmentType.Extensions.toLowerCase().includes('jpeg')) {
            this.fileType = 'image/jpeg';
        }
        else if (this.AttachmentType.Extensions.toLowerCase().includes('pdf')) {
            this.fileType = 'application/pdf';
        }
    }

    onFileSelected(files: File[]) {
        if (files[0].type.toLowerCase() != this.fileType) {
            this.fileTypeInvalid = true;
            this.chosenFile = null;
            return;
        }

        if (files[0].size < this.AttachmentType.LowerSizeLimit) {
            this.fileSizeUnder = true;
            this.chosenFile = null;
            return;
        }

        if (files[0].size > this.AttachmentType.SizeLimit) {
            this.fileSizeOver = true;
            this.chosenFile = null;
            return;
        }

        this.fileSizeOver = false;
        this.fileSizeUnder = false;
        this.fileTypeInvalid = false;
        this.chosenFile = files[0];
        this.uploaded.emit(this.chosenFile);
    }

    downloadOriginal() {
        if (!this.NomineeType.FileStorageRoot || !this.AttachmentType.DownloadFile) { return; }
        
        let fileName = this.AttachmentType.DownloadFile;
        let fileStorageURL = this.NomineeType.FileStorageRoot;
        
        this.splashSvc.OpenSplash({
            TitleText: 'Please Wait',
            MessageText: `Downloading file...`
        }).pipe(takeUntil(this._subrelease)).subscribe(() => {
            this.downloadSvc.RetrieveDownload(HttpMethod.GET, 'Api/Services/App/DownloadFile', {
                AuthToken: '',
                FileName: fileName,
                FilePath: fileStorageURL
            }, DownloadFormat.PDF).pipe(takeUntil(this._subrelease)).subscribe(() => {
                this.splashSvc.CloseSplash();
            }, error => this.errSvc.HandleServiceError(error));
        });
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }
}
